
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentcolor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.75 23v-2.736a3.728 3.728 0 000-7.195V1a1 1 0 00-2 0v12.069a3.728 3.728 0 000 7.195V23a1 1 0 002 0zM2 16.667a1.75 1.75 0 111.75 1.75A1.752 1.752 0 012 16.667zM11 1v2.736a3.727 3.727 0 000 7.194V23a1 1 0 002 0V10.93a3.727 3.727 0 000-7.194V1a1 1 0 00-2 0zm2.75 6.333A1.75 1.75 0 1112 5.583a1.752 1.752 0 011.75 1.75zM19.25 1v12.069a3.728 3.728 0 000 7.195V23a1 1 0 002 0v-2.736a3.728 3.728 0 000-7.195V1a1 1 0 00-2 0zM22 16.667a1.75 1.75 0 11-1.75-1.75 1.753 1.753 0 011.75 1.75z"}})])
          )
        }
      }
    